import React from "react";

export type ScheduleSlotMenuItem = {
  id: string;
  label: string;
  onClick: () => void;
  disabled?: boolean;
  tone?: "default" | "primary" | "danger";
};

type Props = {
  coordinate: { x: number; y: number };
  title?: string;
  items: ScheduleSlotMenuItem[];
};

const toneClasses: Record<NonNullable<ScheduleSlotMenuItem["tone"]>, string> = {
  default: "text-slate-700 hover:bg-slate-50",
  primary: "text-[#3182CE] hover:bg-sky-50",
  danger: "text-red-700 hover:bg-red-50",
};

const ScheduleSlotActionMenu: React.FC<Props> = ({
  coordinate,
  title,
  items,
}) => {
  return (
    <div
      className="absolute z-[3] min-w-[220px] max-w-[min(280px,calc(100vw-2rem))] overflow-hidden rounded-xl border border-slate-200 bg-white shadow-lg"
      style={{ left: coordinate.x, top: coordinate.y }}
      role="menu"
    >
      {title ? (
        <div className="border-b border-slate-100 px-4 py-3 text-sm font-semibold text-slate-600">
          {title}
        </div>
      ) : null}

      <div className="flex flex-col p-1.5">
        {items.map((item) => (
          <button
            key={item.id}
            type="button"
            role="menuitem"
            disabled={item.disabled}
            onClick={item.onClick}
            className={`w-full rounded-lg px-3 py-2.5 text-left text-sm font-medium transition disabled:cursor-not-allowed disabled:opacity-50 ${
              toneClasses[item.tone ?? "default"]
            }`}
          >
            {item.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScheduleSlotActionMenu;
